import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent  {

   constructor(private router: Router) {}

  scrollToTop(): void {
    (document.scrollingElement || document.documentElement || document.body).scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  goToFaq() {
    // Pass a state flag to indicate scroll after navigation
    this.router.navigate(['/live-session'], { state: { scrollToFaq: true } });
  }

}
